import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import SuspenseWithLoader from '../SuspenseWithLoader';
import PDPHeroShell from './PDPHeroShell';
import PDPHeroShellPlaceholder from './PDPHeroShellPlaceholder';
const PDP = t0 => {
  const $ = _c(14);
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      isEditOrder: t1,
      pdpIsModularBYOProduct: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = t2;
  } else {
    props = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  const isEditOrder = t1 === undefined ? false : t1;
  const pdpIsModularBYOProduct = t2 === undefined ? false : t2;
  let t3;
  if ($[4] !== isEditOrder || $[5] !== pdpIsModularBYOProduct) {
    t3 = <PDPHeroShellPlaceholder isEditOrder={isEditOrder} pdpIsModularBYOProduct={pdpIsModularBYOProduct} />;
    $[4] = isEditOrder;
    $[5] = pdpIsModularBYOProduct;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== isEditOrder || $[8] !== pdpIsModularBYOProduct || $[9] !== props) {
    t4 = <PDPHeroShell isEditOrder={isEditOrder} pdpIsModularBYOProduct={pdpIsModularBYOProduct} {...props} />;
    $[7] = isEditOrder;
    $[8] = pdpIsModularBYOProduct;
    $[9] = props;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <SuspenseWithLoader fallback={t3}>{t4}</SuspenseWithLoader>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
PDP.propTypes = {
  slugOverride: PropTypes.string,
  isEditOrder: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  productOptionsPromise: PropTypes.object,
  productHeroImagePromise: PropTypes.object,
  productCylindoHeroImagePromise: PropTypes.object,
  productBasicDetailsPromise: PropTypes.object,
  productIdentityPromise: PropTypes.object
};
export default PDP;